export default __webpack_public_path__ + "static/media/gabriel-cerutti-1.88e754a6.webp";